<template>
  <div v-if="isReady">
    <div class="relative">

      <div
        class="absolute top-0 left-0 ml-6 z-20"
        style="margin-top: 200px"
        v-if="promos.length > 0">
        <div :key="`promo-${i}`" v-for="(promo, i) in promos">
          <div class="mb-1 ml-4" v-if="promo.icon != null">
            <img :src="promo.icon" class="w-20 h-auto">
          </div>
          <div
            class="text-left shadow py-1 px-4 text-sm mb-1"
            :style="{backgroundColor: `#${promo.label_bg_color}`, color: `#${promo.label_text_color}` }"
            v-else-if="promo.tagline != null"><action-icons icon="brands" class="inline w-4 h-4"></action-icons> {{ promo.tagline }}</div>
        </div>
      </div>

      <div class="absolute top-0 right-0 mr-12 mt-2 z-20" v-if="icons.length > 0">
        <img
          class="w-20 h-auto inline-block ml-2"
          :alt="icon.name"
          :key="`icon-${i}`"
          :src="icon.full_url"
          :title="icon.name"
          v-for="(icon, i) in icons">
      </div>
    </div>

    <div class="flex flex-row items-center mb-2">
      <div class="flex-none"><div class="py-4 px-1 bg-gray-200 hover:bg-main hover:text-white st-all cursor-pointer rounded" @click="prevImage()"><action-icons icon="caret-left" /></div></div>
      <div class="flex-1 px-2 relative">
        <div style="height:400px">
          <pic-zoom
            :url="image.full_url"
            :scale="2"
            :scroll="true"
            :key="`large-${i}`"
            v-for="(image, i) in images"
            v-if="currentImageIndex == i" />
        </div>
      </div>
      <div class="flex-none"><div class="py-4 px-1 bg-gray-200 hover:bg-main hover:text-white st-all cursor-pointer rounded" @click="nextImage()"><action-icons icon="caret-right" /></div></div>
    </div>
    <div class="overflow-x-scroll">
      <div class="flex flex-row">
        <div
          class="flex-none w-16 mr-2 border hover:border-main st-border cursor-pointer p-1"
          :class="currentImage.id == image.id ? 'border-main' : ''"
          :key="`thumb-${i}`"
          v-for="(image, i) in images"
          @click="selectImage(i)">
          <img :src="image.thumb_url" :alt="image.description">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PicZoom from 'vue-piczoom';
export default {
  components: {
    PicZoom
  },
  name: 'product-images-Gallery',
  props: {
    images: {
      type: Array,
      default() {
        return []
      }
    },
    icons: {
      type: Array,
      default() {
        return []
      }
    },
    promos: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      currentImage: {},
      currentImageIndex: 0,
      isReady: false,
    }
  },
  methods: {
    selectImage(index) {
      this.currentImageIndex = index;
      this.currentImage = this.images[index];
    },
    prevImage() {
      if (this.currentImageIndex == 0) {
        this.currentImageIndex = this.images.length - 1;
      } else {
        this.currentImageIndex--;
      }
      this.currentImage = this.images[this.currentImageIndex];
    },
    nextImage() {
      if (this.currentImageIndex == this.images.length - 1) {
        this.currentImageIndex = 0;
      } else {
        this.currentImageIndex++;
      }
      this.currentImage = this.images[this.currentImageIndex];
    }
  },
  mounted() {
    this.currentImage = this.images[0];
    this.isReady = true;
  },
}
</script>
<style>
  .mouse-cover-canvas { top: 177px !important; left: 480px !important;}
</style>